export default __webpack_public_path__ + "static/media/PEXA Refinance Index Methodology.95559f38.pdf";